var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBustaChiusaHeaderActions
    ? _c(
        "div",
        { staticClass: "panoramica-actions" },
        [
          _vm.bustaChiusaProcessing
            ? _c(
                "div",
                { staticClass: "panoramica-actions-waiting" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: 12, width: 2 },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Assegnazione in corso...")]),
                ],
                1
              )
            : _vm.showEsitoBusteText
            ? _c("div", {
                staticClass: "panoramica-actions-esito",
                domProps: { innerHTML: _vm._s(_vm.bustaChiusaEsitoText) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showBusteOpenedOffers
            ? _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    "close-on-content-click": false,
                    "max-width": "360",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-badge",
                              {
                                attrs: {
                                  content: _vm.numeroBusteConOfferta,
                                  color: "white text--text",
                                  overlap: "",
                                  "offset-x": "12",
                                  "offset-y": "12",
                                },
                              },
                              [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          rounded: "",
                                          outlined: "",
                                          color: "white",
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", left: "" } },
                                      [_vm._v("receipt_long")]
                                    ),
                                    _vm._v("\n          Offerte\n        "),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1639338313
                  ),
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-card",
                    { staticClass: "mt-1" },
                    [
                      _c(
                        "v-list",
                        {
                          staticClass: "panoramica-buste-menu",
                          attrs: { dense: "" },
                        },
                        _vm._l(_vm.bustaChiusaOfferteOrdinate, function (off) {
                          return _c(
                            "v-list-item",
                            {
                              key: off.s,
                              class: {
                                "panoramica-buste-offerta--top":
                                  off.o == _vm.migliore_offerta.offerta &&
                                  off.o !== _vm.Constants.OFFERTA.PASSO,
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { attrs: { size: "24" } },
                                [
                                  _c("img", {
                                    attrs: { src: _vm.squadra(off.s).pic },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(off.squadraName) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-subtitle",
                                    {
                                      staticClass:
                                        "panoramica-buste-offerta-time",
                                    },
                                    [
                                      off.o > _vm.Constants.OFFERTA.PASSO
                                        ? [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "text--text",
                                                attrs: { "x-small": "" },
                                              },
                                              [_vm._v("schedule")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.bustaChiusaOffertaTime(
                                                    off.s
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        : [_vm._v("Nessuna offerta")],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-action",
                                [
                                  off.o !== _vm.Constants.OFFERTA.PASSO
                                    ? _c("crediti", {
                                        attrs: {
                                          crediti: off.o,
                                          variant:
                                            off.o ==
                                            _vm.migliore_offerta.offerta
                                              ? "dark"
                                              : "light",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showAvanti
            ? _c(
                "v-btn",
                {
                  attrs: {
                    rounded: "",
                    color: "primary",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.avanti },
                },
                [_vm._v("\n    Avanti\n  ")]
              )
            : _vm.showApriBuste
            ? _c(
                "v-btn",
                {
                  attrs: { rounded: "", color: "primary" },
                  on: { click: _vm.apriBuste },
                },
                [_vm._v("\n    Apri buste\n  ")]
              )
            : _vm.waitingAdminOpenBuste
            ? _c(
                "div",
                { staticClass: "panoramica-actions-waiting" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: 12, width: 2 },
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("In attesa che l'admin apra le buste..."),
                  ]),
                ],
                1
              )
            : _vm.showOfferActions
            ? [
                _c(
                  "v-btn",
                  {
                    attrs: { rounded: "", color: "primary" },
                    on: { click: _vm.showNumpad },
                  },
                  [_vm._v("\n      Offerta\n    ")]
                ),
                _vm._v(" "),
                _vm.roundStep && !_vm.roundStep.min_offerta
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "text--text",
                        attrs: { rounded: "", color: "white" },
                        on: {
                          click: function ($event) {
                            return _vm.setPasso(true)
                          },
                        },
                      },
                      [_vm._v("\n      Passo\n    ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showBustaChiusaAutoConfirmHint
                  ? _c("div", { staticClass: "panoramica-busta-hint" }, [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.bustaChiusaAutoConfirmHint) +
                          "\n    "
                      ),
                    ])
                  : _vm._e(),
              ]
            : _vm.showPassatoHint
            ? _c("div", { staticClass: "panoramica-busta-hint" }, [
                _vm._v("\n    " + _vm._s(_vm.bustaChiusaPassoText) + "\n  "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showWaitingOtherParticipants
            ? _c(
                "div",
                { staticClass: "panoramica-actions-waiting" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: 12, width: 2 },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("In attesa degli altri partecipanti...")]),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }